import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddUpdateExamSchedule = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [titleName, setTitleName] = useState('');
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState('');
    const [examType, setExamType] = useState('');
    const [examTypeErr, setExamTypeErr] = useState(false);
    const [examTypeErrText, setExamTypeErrText] = useState('');
    const [classList, setClassList] = useState([]);
    const [subjectList, setSubjectList] = useState([]);
    const [filteredSubjectList, setFilteredSubjectList] = useState([]);
    const [examTypeList, setExamTypeList] = useState([]);
    const [className, setClassName] = useState('');
    const [classDetailId, setClassDetailId] = useState('');
    const [classNameErr, setClassNameErr] = useState(false);
    const [classNameErrText, setClassNameErrText] = useState('');
    const [applyStartTimeToAll, setApplyStartTimeToAll] = useState(false);
    const [applyEndTimeToAll, setApplyEndTimeToAll] = useState(false);
    const [originalTimes, setOriginalTimes] = useState({});
    const [examStartDate, setExamStartDate] = useState(null);
    const [examEndDate, setExamEndDate] = useState(null);
    const [isClassTeacher, setIsClassTeacher] = useState(true);
    const [isSubjectTeacher, setIsSubjectTeacher] = useState(true);
    const [termList, setTermList] = useState([]);
    const [termName, setTermName] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const submitButtonRef = useRef(null);
    const titleNameRef = useRef(null);
    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const [isAcademicYearApply, setIsAcademicYearApply] = useState(false);
    const [isNotificationAllow, setIsNotificationAllow] = useState(true);
    const [timeValidationErr, setTimeValidationErr] = useState('');

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassList(loginData?._id, props?.masterData?.FinancialYearId || props?.financialYearId);
        GetTermsList(loginData?._id);
        if (props?.configId || props?.isCopy) {
            setTitleName(props?.masterData?.TitleName);
            setTermName(props?.masterData?.TermId);
            setSelectedYear(props?.masterData?.FinancialYearId || props?.financialYearId);
            setExamStartDate(props?.masterData?.StartDate ? new Date(props?.masterData?.StartDate) : '');
            setExamEndDate(props?.masterData?.EndDate ? new Date(props?.masterData?.EndDate) : '');
            setIsNotificationAllow(props?.masterData?.IsNotificationAllow);
            if (props?.isCopy) {
                setExamType('');
                setClassName('');
                setClassDetailId('');
            } else {
                setExamType(props?.masterData?.ExamType);
                setClassName(props?.masterData?.ClassId);
                setClassDetailId(props?.masterData?.ClassDetailId || '');
                if (props?.masterData?.ClassId) {
                    GetExamTypeList(loginData?._id, props?.masterData?.ClassId, props?.masterData?.FinancialYearId, props?.masterData?.ClassDetailId);
                }
            }
        } else {
            setSelectedYear(props?.financialYearId);
        }
        GetConfigurationData(loginData?._id);
    }, []);

    useEffect(() => {
        const originalData = {};
        filteredSubjectList?.forEach((row) => {
            originalData[row._id] = { StartTime: row.StartTime, EndTime: row.EndTime };
        });
        setOriginalTimes(originalData);
    }, [applyStartTimeToAll, applyEndTimeToAll]);

    useEffect(() => {
        if (isAcademicYearApply) {
            const academicCalendar = props.academicYearList || [];

            if (!academicCalendar.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const validRanges = academicCalendar.filter(
                item => item?.StartDate && item.EndDate && item?._id === selectedYear
            );

            if (!validRanges.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const sortedCalendar = [...validRanges].sort(
                (a, b) =>
                    new Date(a?.StartDate) - new Date(b?.StartDate)
            );

            const start = new Date(sortedCalendar[0]?.StartDate);
            const end = new Date(sortedCalendar[0]?.EndDate);

            setAcademicStartDate(start);
            setAcademicEndDate(end);
        }
    }, [selectedYear, props.academicYearList, isAcademicYearApply]);

    const handleCheckboxChange = (field, value, setApplyState) => {
        setApplyState(value);
        if (value) {
            applyToAll(field, filteredSubjectList[0]?.[field]);
        } else {
            revertToOriginal();
        }
    };

    const applyToAll = (field, value) => {
        setFilteredSubjectList(filteredSubjectList?.map((item, index) =>
            index === 0 ? item : { ...item, [field]: value }
        ));
    };

    const revertToOriginal = () => {
        setFilteredSubjectList(filteredSubjectList?.map((item) => ({
            ...item,
            StartTime: originalTimes[item._id]?.StartTime || item.StartTime,
            EndTime: originalTimes[item._id]?.EndTime || item.EndTime,
        })));
    };

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(
                        res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                            ...x,
                            value: x?._id,
                            label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                        }))
                    );
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTermsList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getTermList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTermList(res?.data?.map(x => ({
                        label: x?.TermName,
                        value: x?._id,
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetSubjectList = async (id, classId, examTypeValue, examTypeValueList) => {
        try {
            let data = {
                ClassId: classId,
                UserID: id
            }
            await api.post(APIConstant.path.getSubjectByClassId, data).then(async response => {
                let res = response;
                if (res.success) {
                    let existingSubjects = props?.masterData?.SubjectList ?? [];
                    let newSubjectList = res?.data?.filter(s => s?.Status === 'Active' && s?.IsExamApplicable !== false);
                    const filterdata = examTypeValueList?.find(x => x?.value === examTypeValue ?? examType);
                    if (filterdata?.ExamType == 'Individual') {
                        if (!filterdata?.IsGradeAllow) {
                            newSubjectList = newSubjectList?.filter(z => !z?.IsGrade);
                        }
                    } else if (filterdata && filterdata?.IsGradeAllow) {
                        newSubjectList = newSubjectList?.filter(z => z?.IsGrade);
                    } else if (filterdata?.ExamType == 'Total') {
                        newSubjectList = newSubjectList?.filter(z => z?.IsGrade);
                    } else if (filterdata?.ExamType == 'Re-Exam') {
                        newSubjectList = newSubjectList?.filter(z => !z?.IsGrade);
                    }

                    const existingMap = new Map(
                        existingSubjects?.map(s => [s?._id, s])
                    );

                    const finalSubjects = (newSubjectList ?? [])
                        .filter(s => s?.Status === 'Active')
                        .map(s => {
                            const existing = existingMap?.get(s?._id);
                            if (existing) {
                                return {
                                    ...s,
                                    StartDate: existing.StartDate ? new Date(existing.StartDate) : null,
                                    StartTime: existing.StartTime ? new Date(existing.StartTime) : null,
                                    EndTime: existing.EndTime ? new Date(existing.EndTime) : null,
                                    Marks: !CommonConfig.isEmpty(existing?.Marks) ? existing?.Marks : filterdata?.Marks
                                };
                            }
                            return {
                                ...s,
                                StartDate: null,
                                StartTime: null,
                                EndTime: null,
                                Marks: filterdata?.Marks
                            };
                        });
                    setSubjectList(newSubjectList);
                    setFilteredSubjectList([...finalSubjects]);
                    Loader.hide();
                }

            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetExamTypeList = async (loginId, id, financialId, classDetailIdParam) => {
        try {
            let data = {
                ClassId: classDetailIdParam || id,
                FinancialYearId: financialId,
                UserId: loginId
            }
            await api.post(APIConstant.path.GetResultTemplateListByClassId, data).then(async response => {
                let res = response;
                if (res.success) {
                    const formatedData = res?.data.map((x) => ({
                        ...x,
                        value: x?._id,
                        label: `${x?.Name} (${x?.ShortName ? `${x.ShortName} - ` : ''}${x?.Marks})`
                    }));

                    setExamTypeList(formatedData);
                    if (!CommonConfig.isEmpty(props?.configId)) {
                        await GetSubjectList(loginId, classDetailIdParam || id, CommonConfig.isEmpty(examType) ? props?.masterData?.ExamType : examType, formatedData);
                    }
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setIsClassTeacher(props?.masterData?.IsClassTeacher ? props?.masterData?.IsClassTeacher : res?.data?.IsClassTeacher);
                    setIsSubjectTeacher(props?.masterData?.IsSubjectTeacher ? props?.masterData?.IsSubjectTeacher : res?.data?.IsSubjectTeacher);
                    setIsAcademicYearApply(res?.data?.IsAcademicYearApply);

                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(titleName)) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Title Name is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        if (CommonConfig.isEmpty(className)) {
            formIsValid = false;
            setClassNameErr(true);
            setClassNameErrText("Class name is required");
        } else {
            setClassNameErr(false);
            setClassNameErrText("");
        }
        if (CommonConfig.isEmpty(examType)) {
            formIsValid = false;
            setExamTypeErr(true);
            setExamTypeErrText("Exam type is required");
        } else {
            setExamTypeErr(false);
            setExamTypeErrText("");
        }
        if (filteredSubjectList.length == 0) {
            formIsValid = false;
            setTitleNameErr(true);
            setTitleNameErrText("Atleast one subject is required");
        } else {
            setTitleNameErr(false);
            setTitleNameErrText("");
        }
        setTimeValidationErr('');
        for (let i = 0; i < filteredSubjectList.length; i++) {
            const item = filteredSubjectList[i];
            if (item.StartTime && item.EndTime) {
                const start = new Date(item.StartTime);
                const end = new Date(item.EndTime);
                if (!isNaN(start) && !isNaN(end)) {
                    const startMinutes = start.getHours() * 60 + start.getMinutes();
                    const endMinutes = end.getHours() * 60 + end.getMinutes();
                    if (endMinutes <= startMinutes) {
                        formIsValid = false;
                        setTimeValidationErr(`To Time must be greater than From Time for ${item.SubjectName}`);
                        break;
                    }
                }
            }
        }
        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
        setTitleName('');
        setExamType('');
        setClassName('');
        setClassDetailId('');
        setFilteredSubjectList([]);
        setSubjectList([]);
        setExamType('');
        setExamTypeList([]);
    }

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                var subData = filteredSubjectList?.map(x => ({
                    SubjectId: x?._id,
                    StartDate: x?.StartDate,
                    StartTime: x?.StartTime,
                    EndTime: x?.EndTime,
                    Marks: x?.Marks
                }));
                let data = {
                    id: props?.configId,
                    TitleName: titleName,
                    ExamType: examType,
                    ClassId: className,
                    ClassDetailId: classDetailId,
                    StartDate: examStartDate,
                    EndDate: examEndDate,
                    IsClassTeacher: isClassTeacher,
                    IsSubjectTeacher: isSubjectTeacher,
                    Subjects: subData,
                    TermId: termName,
                    FinancialYearId: selectedYear,
                    IsNotificationAllow: isNotificationAllow,
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateExamSchedule, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Toast.error({ message: err?.message });
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const actionBodyTemplateSrNo = (rowData, { rowIndex }) => {
        return rowIndex + 1;
    };

    const onChangeClass = async (classDetailIdValue) => {
        const selected = classList?.find(c => c?.value === classDetailIdValue);
        const classNoId = selected?.ClassId;
        setClassDetailId(classDetailIdValue || '');
        setClassName(classNoId || '');
        setExamType('');
        setSubjectList([]);
        setFilteredSubjectList([]);
        setExamTypeList([]);
        if (classNoId) {
            GetExamTypeList(securityUserID, classNoId, selectedYear, classDetailIdValue);
        }
    };

    const handleExamType = async (value) => {
        await GetSubjectList(securityUserID, classDetailId || className, CommonConfig.isEmpty(value) ? props?.masterData?.ExamType : value, examTypeList);
        setExamType(value);
    }

    const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toLocaleDateString('en-GB');
    };

    const formatTime = (date) => {
        if (!date) return "";
        return new Date(date).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    const dayTemplate = (rowData) => {
        if (!rowData?.StartDate) return "";

        const day = new Date(rowData?.StartDate).toLocaleDateString('en-US', { weekday: 'long' });
        return <span className="day-pill">{day}</span>;
    };

    const isEndTimeBeforeStartTime = (startTime, endTime) => {
        if (!startTime || !endTime) return false;
        const start = new Date(startTime);
        const end = new Date(endTime);
        const startMinutes = start.getHours() * 60 + start.getMinutes();
        const endMinutes = end.getHours() * 60 + end.getMinutes();
        return endMinutes <= startMinutes;
    };

    const onRowEditComplete = (e) => {
        let { newData, index } = e;
        if (isEndTimeBeforeStartTime(newData.StartTime, newData.EndTime)) {
            Toast.error({ message: 'To Time must be greater than From Time' });
            return;
        }
        setFilteredSubjectList((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], ...newData };
            return updated;
        });
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between" style={{ height: '100%', flex: 1 }}>
            <div className='p-grid' style={{ overflowY: 'auto', overflowX: 'hidden', flex: 1, paddingRight: '5px' }}>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="titleName">Exam Name<span style={{ color: "red" }}>*</span></label>
                        <InputText
                            ref={titleNameRef}
                            className='p-w-100 p-mt-1'
                            id="titleName"
                            value={titleName}
                            maxLength={20}
                            onChange={(e) => setTitleName(e.target.value)}
                            style={{
                                fontFamily: "Noto Sans, Arial, sans-serif"
                            }}
                        />
                    </div>
                    <span className="error-msg" style={{ color: 'red' }}>
                        {titleNameErr ? titleNameErrText : null}
                    </span>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="className">Class<span style={{ color: "red" }}>*</span></label>
                        <Dropdown
                            id="className"
                            value={classDetailId}
                            options={classList}
                            onChange={(e) => onChangeClass(e.value)}
                            placeholder="Select Class"
                            display="chip"
                            className='p-w-100 p-mt-1'
                            filter
                            showClear
                        />
                        <span className="error-msg" style={{ color: 'red' }}>
                            {classNameErr ? classNameErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="examType">Exam Type<span style={{ color: "red" }}>*</span></label>
                        <Dropdown
                            id="examType"
                            value={examType}
                            options={examTypeList}
                            onChange={(e) => handleExamType(e.value)}
                            placeholder="Select Exam Type"
                            display="chip"
                            className='p-w-100 p-mt-1'
                            filter
                            showClear
                        />
                        <span className="error-msg" style={{ color: 'red' }}>
                            {examTypeErr ? examTypeErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="selectedYear">Academic Years</label>
                        <Dropdown
                            id="selectedYear"
                            value={selectedYear}
                            minDate={academicStartDate}
                            maxDate={academicEndDate}
                            options={props?.academicYearList}
                            onChange={(e) => setSelectedYear(e.value)}
                            placeholder="Select Academic Year"
                            display="chip"
                            className='p-w-100 p-mt-1'
                            filter
                            optionLabel="label"
                            optionValue="_id"
                            showClear
                        />
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="p-mt-5">
                        <Checkbox
                            inputId="classTeacher"
                            name="isClassTeacher"
                            value="IsClassTeacher"
                            onChange={(e) => {
                                setIsClassTeacher(e.checked);
                            }}
                            checked={isClassTeacher}
                        />
                        <label htmlFor="classTeacher" className="ml-2"> Class Teacher</label>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="p-mt-5">
                        <Checkbox
                            inputId="subjectTeacher"
                            name="isSubjectTeacher"
                            value="IsSubjectTeacher"
                            onChange={(e) => {
                                setIsSubjectTeacher(e.checked);
                            }}
                            checked={isSubjectTeacher}
                        />
                        <label htmlFor="subjectTeacher" className="ml-2"> Subject Teacher</label>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="p-mt-5">
                        <Checkbox
                            inputId="isNotificationAllow"
                            name="isNotificationAllow"
                            value={isNotificationAllow}
                            onChange={(e) => {
                                setIsNotificationAllow(e.checked);
                            }}
                            checked={isNotificationAllow}
                        />
                        <label htmlFor="isNotificationAllow" className="ml-2"> Notification Allow</label>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="startDate">Start Date</label>
                        <Calendar
                            className='p-w-100 p-mt-1'
                            id='startDate'
                            value={examStartDate}
                            minDate={academicStartDate}
                            maxDate={academicEndDate}
                            onChange={(e) => setExamStartDate(e.value)}
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="endDate">End Date</label>
                        <Calendar
                            className='p-w-100 p-mt-1'
                            id='endDate'
                            minDate={CommonConfig.parseDDMMYYYYToDate(examStartDate) ?? academicStartDate}
                            maxDate={academicEndDate}
                            value={examEndDate}
                            onChange={(e) => setExamEndDate(e.value)}
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="term">Terms</label>
                        <div className="custom-inputs">
                            <Dropdown
                                id="term"
                                value={termName}
                                options={termList}
                                onChange={(e) => setTermName(e.value)}
                                placeholder="Select Terms"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                filter
                                showClear
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-12">
                    <DataTable
                        value={filteredSubjectList}
                        editMode="row"
                        dataKey="_id"
                        onRowEditComplete={onRowEditComplete}
                        responsiveLayout="scroll"
                        className='custom-table'
                        scrollHeight='calc(100vh - 500px)'
                        size='small'
                        emptyMessage="Select a Class and Exam Type to load subjects."
                    >
                        <Column field="SrNo" body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column field="SubjectName" header="Subject" />
                        <Column field="SubjectId" header="Subject Code" />
                        <Column field="StartDate" header="Date" editor={(options) => (
                            <Calendar
                                value={options.value}
                                onChange={(e) => {
                                    options.editorCallback(e.value);
                                    setFilteredSubjectList((prev) => {
                                        const updated = [...prev];
                                        updated[options.rowIndex] = { ...updated[options.rowIndex], StartDate: e.value };
                                        return updated;
                                    });
                                }}
                                dateFormat="dd/mm/yy"
                                minDate={CommonConfig.parseDDMMYYYYToDate(examStartDate) ?? academicStartDate}
                                maxDate={CommonConfig.parseDDMMYYYYToDate(examEndDate) ?? academicEndDate}
                            />
                        )}
                            body={(rowData) => formatDate(rowData?.StartDate)} />
                        <Column field="Day" header="Day" body={dayTemplate} />
                        <Column
                            field="StartTime"
                            header={
                                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    From Time
                                    <Checkbox
                                        onChange={(e) => handleCheckboxChange("StartTime", e.checked, setApplyStartTimeToAll)}
                                        checked={applyStartTimeToAll}
                                    />
                                </div>
                            }
                            editor={(options) => (
                                <Calendar
                                    value={options.value}
                                    onChange={(e) => {
                                        const rowData = filteredSubjectList[options.rowIndex];
                                        if (rowData?.EndTime && isEndTimeBeforeStartTime(e.value, rowData.EndTime)) {
                                            Toast.error({ message: 'From Time must be less than To Time' });
                                            return;
                                        }
                                        options.editorCallback(e.value);
                                        setFilteredSubjectList((prev) => {
                                            const updated = [...prev];
                                            updated[options.rowIndex] = { ...updated[options.rowIndex], StartTime: e.value };
                                            return updated;
                                        });
                                    }}
                                    showTime
                                    timeOnly
                                    hourFormat="12"
                                />
                            )}
                            body={(rowData) => formatTime(rowData?.StartTime)}
                        />
                        <Column
                            field="EndTime"
                            header={
                                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    To Time
                                    <Checkbox
                                        onChange={(e) => handleCheckboxChange("EndTime", e.checked, setApplyEndTimeToAll)}
                                        checked={applyEndTimeToAll}
                                    />
                                </div>
                            }
                            editor={(options) => (
                                <Calendar
                                    value={options.value}
                                    onChange={(e) => {
                                        const rowData = filteredSubjectList[options.rowIndex];
                                        if (isEndTimeBeforeStartTime(rowData?.StartTime, e.value)) {
                                            Toast.error({ message: 'To Time must be greater than From Time' });
                                            return;
                                        }
                                        options.editorCallback(e.value);
                                        setFilteredSubjectList((prev) => {
                                            const updated = [...prev];
                                            updated[options.rowIndex] = { ...updated[options.rowIndex], EndTime: e.value };
                                            return updated;
                                        });
                                    }}
                                    showTime
                                    timeOnly
                                    hourFormat="12"
                                />
                            )}
                            body={(rowData) => formatTime(rowData?.EndTime)}
                        />
                        <Column
                            field="Marks"
                            header="Marks"
                            body={(rowData) => rowData?.Marks ?? ''}
                            editor={(options) => {
                                return (
                                    <InputText
                                        type="text"
                                        value={options.value != null ? String(options.value) : ''}
                                        onChange={(e) => {
                                            options.editorCallback(e.target.value);
                                            setFilteredSubjectList((prev) => {
                                                const updated = [...prev];
                                                updated[options.rowIndex] = { ...updated[options.rowIndex], Marks: e.target.value };
                                                return updated;
                                            });
                                        }}
                                        maxLength={3}
                                    />
                                );
                            }}
                        />
                        <Column
                            rowEditor
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ textAlign: 'center' }}
                        />
                        <Column
                            header="Remove"
                            headerStyle={{ width: '5rem' }}
                            bodyStyle={{ textAlign: 'center' }}
                            body={(rowData) => (
                                <Button
                                    type="button"
                                    icon="pi pi-trash"
                                    className="p-button-text p-button-danger p-button-sm"
                                    onClick={() => setFilteredSubjectList((prev) => prev.filter(r => r?.SubjectId !== rowData?.SubjectId))}
                                    tooltip="Remove from exam timetable"
                                />
                            )}
                        />
                    </DataTable>
                </div>
            </div>
            {timeValidationErr && (
                <div className="p-col-12">
                    <span className="error-msg" style={{ color: 'red', fontWeight: 'bold' }}>{timeValidationErr}</span>
                </div>
            )}
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-mb-2">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary submit-focus' label="Save" onClick={(e) => AddUpdateTemplate()} />
            </div>
        </div >
    );
};

export default AddUpdateExamSchedule;
